import { fetchApi } from '@/config/axiosSetting';
import { PatchPartTwoVehicleInformationType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchPartTwoVehicleInformation/patchPartTwoVehicleInformation.type';

export const patchPartTwoVehicleInformationFunction = ({
  id,
  damaged_id,
  data,
}: PatchPartTwoVehicleInformationType) => {
  return fetchApi.patch(
    `/property/reports/${id}/accident_users/damaged/vehicle_information/part_two/?damaged_id=${damaged_id}`,
    {
      ...data,
    },
  );
};
